import { useTranslation } from "react-i18next";
import { useSnapshot } from "valtio";
import { useSelector, useDispatch } from "react-redux";

import { store } from "@components/VerticalLayout/store";
import { getUuidUser } from "@helpers/getUuidUser";

import { useFetchGlobal } from "../../../../api/hooks";

import { RootState, AppDispatch } from "../../../../redux/store";
import { setIsSupportCodeValid } from "../../../../redux/slices/fidelitySlice";
import { archiveFidelity } from "../helpers";


type Params = {
    setIsModalOpened: (v: boolean) => void;
    selectedRows: FidelityRow[];
    e?: { selectedRow: FidelityRow };
    setCodeSupport?: React.Dispatch<React.SetStateAction<string>>;
};

export function useArchiveActions({
    setIsModalOpened,
    selectedRows,
    e,
    setCodeSupport,
}: Params) {
    const { t } = useTranslation();
    const { franchiseID, userID, operatorID } = useSnapshot(store);
    const shopsFidelityData = useSelector(
        (s: RootState) => s.fidelity.shopsFidelityData
    );
    const dispatch = useDispatch<AppDispatch>();
    const { fetchGlobal } = useFetchGlobal();
    const uuidUser = getUuidUser();

    const resetSupportCode = () => {
        dispatch(setIsSupportCodeValid(false));
        setCodeSupport && setCodeSupport("");
    };

    const cancel = () => {
        setIsModalOpened(false);
        resetSupportCode();
    };

    const confirm = () => {
        archiveFidelity({
            selectedRows,
            e,
            shopsFidelityData,
            ctx: {
                userID,
                franchiseID,
                operatorID,
                uuidUser,
                fetchGlobal,
                t,
            },
        });
        setIsModalOpened(false);
        resetSupportCode();
    };

    return { t, cancel, confirm };
}
